import {LOAD_DATA, START, SUCCESS, FAIL, STORE} from "../../../constants";
import {SAVE_ADMIN_SETUP} from "../constants";

export default (
  products = {
    items: [],
    loading: false,
    loaded: true
  },
  action
) => {
  const {type, payload, response, error} = action;

  switch (type) {
    case STORE + LOAD_DATA + START:
      return {...products, loading: true, loaded: false};
    case STORE + LOAD_DATA + SUCCESS:
      return payload.addProducts
        ? {
            items: [...products.items, ...response.products.items],
            loading: false,
            loaded: true
          }
        : {items: response.products.items, loading: false, loaded: true};
    case STORE + LOAD_DATA + FAIL:
      return {...products, loading: false, loaded: false, error};

    case SAVE_ADMIN_SETUP + START:
      return {...products, loading: true, loaded: false};
    case SAVE_ADMIN_SETUP + SUCCESS:
      return (() => {
        const items = products.items.map((i) => {
          if (i.admin.action === response.action) {
            return {
              ...i,
              admin: {
                ...i.admin,
                ...response
              }
            };
          }
          return i;
        });
        return {
          items,
          loading: false,
          loaded: true
        };
      })();
    case SAVE_ADMIN_SETUP + FAIL:
      return {...products, loading: false, loaded: false, error};
  }
  return products;
};
